import { FC } from 'react';
import SideBySideLayout, { SideBySideLayoutProps } from './SideBySideLayout';
import { ReactComponent as LogoTop } from '../../../assets/images/logos/logoTop.svg';
import { ReactComponent as LogoMain } from '../../../assets/images/logos/logoMain.svg';
import { ReactComponent as LogoBottom } from '../../../assets/images/logos/logoBottom.svg';
import { ReactComponent as WarningIcon } from '../../../assets/icons/warning.svg';
import { SmallScreenLogo } from '../../../assets/icons';
import Alert from '../../../components/Alert';

type AuthLayoutProps = Omit<SideBySideLayoutProps, 'leftBox'> & {
  error?: { body: string | null; onClose?: () => void };
};

const AuthLayout: FC<AuthLayoutProps> = ({ title, subTitle, children, styles, error, classNames }) => {
  return (
    <SideBySideLayout
      title={title}
      subTitle={subTitle}
      classNames={{
        title: `text-xl sm:text-2xl font-semibold mb-3 text-center text-gray-900 dark:text-white ${
          (classNames || { title: '' }).title
        }`,
        subTitle: `text-sm sm:text-base text-center text-gray-500 dark:text-gray-400 ${
          (classNames || { subTitle: '' }).subTitle
        }`,
        main: `bg-gradient-to-br from-gray-50 via-white to-gray-100 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 h-screen ${
          (classNames || { main: '' }).main
        }`,
        left: 'h-32 sm:h-40 w-full overflow-hidden sm:h-screen sm:w-[38%] lg:w-1/3',
        right: 'flex-col flex-1 sm:justify-center items-center p-6 sm:p-8',
      }}
      styles={styles}
      leftBox={
        <div id="logo-wrapper" className="relative w-full h-full">
          {/* Mobile header with gradient */}
          <div className="flex items-center justify-center bg-gradient-to-br from-vine via-vine to-vine/90 p-8 w-full sm:hidden shadow-lg">
            <SmallScreenLogo className="h-8 w-auto" />
          </div>
          {/* Desktop side panel */}
          <div className="hidden sm:flex w-full h-full flex-col relative overflow-hidden">
            <LogoTop className="top-0 w-full flex-1" />
            <LogoMain className="h-auto" />
            <LogoBottom className="bottom-0 w-full flex-1" />
            {/* Subtle overlay for depth */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent pointer-events-none" />
          </div>
        </div>
      }
    >
      <>
        {error && error.body && error.body.length > 0 && (
          <Alert
            className="bg-red absolute top-4 w-[85%] max-w-md text-sm text-white rounded-xl shadow-lg shadow-red/25 animate-[fade-in_0.3s_ease-out]"
            show={true}
            onClose={() => {
              if (error.onClose) error.onClose();
            }}
            icon={<WarningIcon className="text-white" />}
          >
            {error.body}
          </Alert>
        )}
        {children}
      </>
    </SideBySideLayout>
  );
};

export default AuthLayout;
